// AutoCookies.js
import Cookies from "js-cookie";

const COOKIE_LIMIT = 4093; // ~4KB per cookie

const AutoCookies = {
    set: (key, value, options = {}) => {
        const strValue = typeof value === "string" ? value : JSON.stringify(value);

        if (strValue.length <= COOKIE_LIMIT) {
            // small enough → cookie
            Cookies.set(key, strValue, options);
            localStorage.removeItem(key);
        } else {
            // too large → localStorage
            localStorage.setItem(key, strValue);
            Cookies.remove(key);
        }
    },

    get: (key) => {
        const fromCookie = Cookies.get(key);
        if (fromCookie !== undefined) return fromCookie;

        const fromLS = localStorage.getItem(key);
        return fromLS !== null ? fromLS : undefined;
    },

    remove: (key) => {
        Cookies.remove(key);
        localStorage.removeItem(key);
    }
};

export default AutoCookies;
